import { useCallback, useEffect, useRef, useState } from "react";

export function useAsync<T>(loader: () => Promise<T>, dependencies: unknown[] = []) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const mounted = useRef(true);
  const run = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const result = await loader();
      if (mounted.current) setData(result);
      return result;
    } catch (caught) {
      if (mounted.current) setError(caught instanceof Error ? caught.message : "Произошла ошибка");
      return null;
    } finally {
      if (mounted.current) setLoading(false);
    }
  }, dependencies);
  useEffect(() => {
    mounted.current = true;
    void run();
    return () => { mounted.current = false; };
  }, [run]);
  return { data, error, loading, reload: run, setData };
}

export function useDebouncedEffect(effect: () => void | (() => void), delay: number, dependencies: unknown[]) {
  useEffect(() => {
    const timer = window.setTimeout(effect, delay);
    return () => window.clearTimeout(timer);
  }, [...dependencies, delay]);
}

